// src/components/Navbar/index.js

import React, { Component } from 'react';

import { connect } from "react-redux";
import { Navbar } from '@nike/ruxac';
 import config from '../../config/oAuthConfig'


import { logoutUser, selectEmail, selectName } from '../auth/index';
import './index.scss'


    class NavBar extends Component {

    constructor(props) {
        super(props);
        this.text = "PCX Data Loader App";

    }

    render() {
        const {
            user
           
        } = this.props;
  
        return (
            <Navbar
                
                appTitle={this.text}
                user={user}  
                loginComponent={<a onClick={(e) => {
                    e.preventDefault();
                   
                }} href="/login">Login</a>}

                logoutComponent={<a  onClick={() => this.props.logoutUser()} href={config.pathName} test="test,,,">Logout</a>}
                History    
                {...this.props}
                
               
            />
        );
    }
}
const mapStateToProps = (state) => {
    return {
      email: selectEmail(state),
      userName: selectName(state),
    };
  };



  const ConnectedComponent = connect(mapStateToProps, { logoutUser })(NavBar);
export default ConnectedComponent;



